<script>
	import { createEventDispatcher, getContext } from 'svelte'
	import { slide } from 'svelte/transition'
	import { format, add } from 'date-fns'
	import { styles } from '../scripts/styles.js'

	//date command start/end etc
	export let cmd = 'start'

	//disable previous deys of month
	export let disablePrevious = false

	//font sizes
	const globals = getContext('globals')
	export let fsXLarge = globals.fsN
	export let fsLarge = globals.fsS
	export let fsS = globals.fsXS

	//colors
	export let backgroundColor = 'hsla(0,0%,70%,1)'
	export let colorSelected = 'red'
	export let colorDisabled = 'hsl(0,0%,75%)'
	export let color = 'black'
	export let colorBorder = 'green'
	export let colorHover = 'blue'
	export let colorShadow = 'hsla(0,0%,0%,1)'
	export let shadowX = '5px'
	export let shadowY = '5px'
	export let shadowB = '5px'
	export let fontFamily = 'Lucida Sans'
	export let selectionDate = false

	//the initial date to set
	let date = new Date()
	let displayDate

	if (cmd === 'end')
		date = add(date, {
			days: 1,
		})

	let dispatch = createEventDispatcher()

	//show/hide the content container
	let showDate = false

	//abrev days
	const abrDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

	//the days full
	const fulDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	const fulMonths = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	]

	//one day in milliseconds (to calculate with timestamps)
	let oneDay = 60 * 60 * 24 * 1000

	//the initial date
	let year = date.getFullYear()
	let month = date.getMonth()

	//the display date
	$: if (selectionDate) displayDate = format(date, 'dd/MM/yyyy')
	$: if (!selectionDate) displayDate = 'select date'

	//the initial timestamp
	let todayTimestamp = Date.now() - (Date.now() % oneDay) + new Date().getTimezoneOffset() * 1000 * 60

	let calendarDetails = {
		year: year,
		month: month,
		selectedDay: todayTimestamp,
		monthDetails: getMonthDetails(year, month),
	}

	const change_year = (cmd, year) => {
		if (cmd === 'plus') year += 1
		if (cmd === 'minus') year -= 1

		calendarDetails.year = year
		calendarDetails.month = calendarDetails.month
		calendarDetails.selectedDay = null
		calendarDetails.monthDetails = getMonthDetails(year, calendarDetails.month)
	}

	const change_month = (cmd, month) => {
		if (cmd === 'plus') {
			if (month === 11) {
				month = 0
				calendarDetails.year += 1
			} else month += 1
		}
		if (cmd === 'minus') {
			if (month === 0) {
				month = 11
				calendarDetails.year -= 1
			} else month -= 1
		}

		calendarDetails.year = calendarDetails.year
		calendarDetails.month = month
		calendarDetails.selectedDay = null
		calendarDetails.monthDetails = getMonthDetails(calendarDetails.year, month)
	}

	const show_dates = () => {
		showDate = showDate === false ? true : false
	}

	const set_date = (tstamp) => {
		selectionDate = true
		date = new Date(tstamp)
		showDate = false
		dispatch('getdate', {
			cmd: cmd,
			value: format(date, 'd/M/yyyy'),
		})
	}

	//functions must have access everywhere

	function getNumberOfDays(year, month) {
		return 40 - new Date(year, month, 40).getDate()
	}

	function getDayDetails(args) {
		let date = args.index - args.firstDay
		let day = args.index % 7
		let prevMonth = args.month - 1
		let prevYear = args.year
		if (prevMonth < 0) {
			prevMonth = 11
			prevYear--
		}

		let prevMonthNumberOfDays = getNumberOfDays(prevYear, prevMonth)
		let _date = (date < 0 ? prevMonthNumberOfDays + date : date % args.numberOfDays) + 1
		let month = date < 0 ? -1 : date >= args.numberOfDays ? 1 : 0
		let timestamp = new Date(args.year, args.month, _date).getTime()

		return {
			date: _date,
			day,
			month,
			timestamp,
			dayString: fulDays[day],
		}
	}
	function getMonthDetails(year, month) {
		//first day of the month
		let firstDay = new Date(year, month).getDay()

		//number of days in month
		let numberOfDays = getNumberOfDays(year, month)

		//the month details
		let monthArray = []

		//the grid
		let rows = 6
		let cols = 7

		let currentDay = null

		//the array index
		let index = 0

		//populate the monthArray
		for (let row = 0; row < rows; row++) {
			for (let col = 0; col < cols; col++) {
				currentDay = getDayDetails({
					index,
					numberOfDays,
					firstDay,
					year,
					month,
				})
				monthArray.push(currentDay)
				index++
			}
		}
		return monthArray
	}
</script>

<main>
	<input
		use:styles={{ fsLarge, color, colorBorder, colorShadow, shadowX, shadowY, shadowB, backgroundColor, fontFamily }}
		type="text"
		bind:value={displayDate}
		on:click={show_dates}
		readonly
	/>
	{#if showDate}
		<div
			transition:slide={{ duration: 1000 }}
			use:styles={{ fsS, color, colorBorder, colorShadow, shadowX, shadowY, shadowB, backgroundColor, fontFamily }}
			class="container"
		>
			<div class="cc_control">
				<div
					use:styles={{ colorHover, fsXLarge }}
					class="change_button"
					on:click={() => change_year('minus', calendarDetails.year)}
					on:keydown={() => change_year('minus', calendarDetails.year)}
				>
					&#171;
				</div>
				<div
					use:styles={{ colorHover, fsXLarge }}
					class="change_button"
					on:click={() => change_month('minus', calendarDetails.month)}
					on:keydown={() => change_month('minus', calendarDetails.month)}
				>
					&#8249;
				</div>
				<div>{calendarDetails.year}</div>
				<div
					use:styles={{ colorHover, fsXLarge }}
					class="change_button"
					on:click={() => change_month('plus', calendarDetails.month)}
					on:keydown={() => change_month('plus', calendarDetails.month)}
				>
					&#8250
				</div>
				<div
					use:styles={{ colorHover, fsXLarge }}
					class="change_button"
					on:click={() => change_year('plus', calendarDetails.year)}
					on:keydown={() => change_year('plus', calendarDetails.year)}
				>
					&#187
				</div>
			</div>
			<div class="cc_date">{fulMonths[calendarDetails.month]}</div>
			<div class="cc_content">
				{#each abrDays as day}
					<div>{day}</div>
				{/each}
				{#each calendarDetails.monthDetails as detail}
					{#if detail.month !== 0}
						<div use:styles={{ colorDisabled }} class="day disabled">
							{detail.date}
						</div>
					{:else if disablePrevious && detail.timestamp < todayTimestamp}
						<div use:styles={{ colorDisabled }} class="day disabled">
							{detail.date}
						</div>
					{:else}
						<!-- current day -->
						{#if todayTimestamp === detail.timestamp}
							<div
								class="day current_day"
								use:styles={{ colorSelected }}
								on:click={() => set_date(detail.timestamp)}
								on:keydown={() => set_date(detail.timestamp)}
							>
								{detail.date}
							</div>
						{:else}
							<div
								class="day"
								use:styles={{ colorHover }}
								on:click={() => set_date(detail.timestamp)}
								on:keydown={() => set_date(detail.timestamp)}
							>
								{detail.date}
							</div>
						{/if}
					{/if}
				{/each}
			</div>
		</div>
	{/if}
</main>

<style>
	main {
		width: clamp(150px, 21vw, 322px);
		user-select: none;
	}

	input {
		width: 100%;
		color: var(--color);
		font-size: var(--fsLarge);
		font-family: var(--fontFamily);
		border-color: var(--colorBorder);
		cursor: pointer;
		text-align: center;
		background-color: var(--backgroundColor);
		box-shadow: var(--shadowX) var(--shadowY) var(--shadowB) var(--colorShadow);
	}

	input:focus {
		outline: none;
	}

	.container {
		border: 1px solid var(--colorBorder);
		color: var(--color);
		font-size: var(--fsS);
		font-family: var(--fontFamily);
		width: 100%;
		height: clamp(190px, 16.3vw, 250px);
		padding: clamp(2px, 0.8vw, 10px);
		background-color: var(--backgroundColor);
		box-shadow: var(--shadowX) var(--shadowY) var(--shadowB) var(--colorShadow);
	}

	.cc_control {
		display: grid;
		grid-template-columns: 0.1fr 0.1fr 0.8fr 0.1fr 0.1fr;
		justify-items: center;
		align-items: center;
		width: 100%;
	}

	.cc_date {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 5px;
		border-bottom: 1px solid green;
		width: 100%;
	}

	.change_button {
		color: var(--color);
		font-size: var(--fsXLarge);
		cursor: pointer;
	}

	.change_button:hover {
		color: var(--colorHover);
	}

	.cc_content {
		display: grid;
		grid-template-columns: repeat(7, 1fr);
		grid-template-rows: repeat(7, 1fr);
		grid-row-gap: 2px;
		grid-column-gap: 2px;
		justify-items: center;
		align-items: center;
		height: 75%;
	}

	.day {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		cursor: pointer;
	}
	.day:hover {
		background-color: var(--colorHover);
	}

	.disabled {
		color: var(--colorDisabled);
	}
	.disabled:hover {
		border: none;
	}

	.current_day {
		color: var(--colorSelected);
	}
</style>
